module.exports = __webpack_public_path__ + "static/media/about-image.99eb49d4.png";